import { render, staticRenderFns } from "./ListReview_opponent.vue?vue&type=template&id=658bcc74&scoped=true"
import script from "./ListReview_opponent.vue?vue&type=script&lang=js"
export * from "./ListReview_opponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658bcc74",
  null
  
)

export default component.exports